module.exports = {
  author: "Arundhati Singh",
  siteUrl: "https://arundhatisingh.com", // Your domain (update this with your actual domain)
  siteShortTitle: "Arundhati", // Used as logo text in header, footer, and splash screen
  siteLanguage: "en_US",
  siteIcon: "content/favicon.png", // Relative to gatsby-config file

  // -- THEME SETTINGS -----
  colors: {
    lightTheme: {
      primary: "#000000",
      secondary: "#FFF4D9",
      tertiary: "#F2F2F2",
      text: "#000000",
      subtext: "#555555",
      background: "#FFFFFF",
      card: "#FFFFFF",
      scrollBar: "rgba(0, 0, 0, 0.5)",
      boxShadow: "rgba(0, 0, 0, 0.16)",
      boxShadowHover: "rgba(0, 0, 0, 0.32)",
    },
    darkTheme: {
      primary: "#FAFAFA",
      secondary: "#2A2926",
      tertiary: "#252525",
      text: "rgba(255, 255, 255, 0.87)",
      subtext: "#AAAAAA",
      background: "#121212",
      card: "#1C1C1C",
      scrollBar: "rgba(255, 255, 255, 0.5)",
      boxShadow: "rgba(0, 0, 0, 0.16)",
      boxShadowHover: "rgba(0, 0, 0, 0.32)",
    },
  },
  fonts: {
    primary: "Roboto, Arial, sans-serif",
  },

  //-- ARTICLES SECTION SETTINGS -----
  // You can create your own Medium feed with this rss to json converter: https://rss2json.com/
  // To access your Medium RSS feed, just replace this url with your username: https://medium.com/feed/@{yourname}
  // mediumRssFeed:
  //   "https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fmedium.com%2Ffeed%2F%40konstantinmuenster",
  // // rssFeed: "https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fwww.theguardian.com%2Finternational%2Frss",

  // shownArticles: 3,

  //-- SPOTIFY SETTINGS -----
  // Your Discord User ID for Lanyard API Spotify integration
  // To find your Discord ID: Enable Developer Mode in Discord Settings > Advanced,
  // then right-click your username and select "Copy ID"
  // NOTE: This should be a numeric ID (e.g., "123456789012345678"), not your username
  discordUserId: "1114255146554249300",

  //-- SOCIAL MEDIA SETTINGS -----
  // There are icons available for the following platforms:
  // Medium, GitHub, LinkedIn, XING, Behance, E-Mail
  socialMedia: [
    {
      name: "Linkedin",
      url: "https://www.linkedin.com/in/arundhati-singh171003/",
    },
    {
      name: "Medium",
      url: "https://medium.com/@arundhatisingh171003",
    },
    {
      name: "Github",
      url: "https://github.com/arundhatisingh17",
    },
    {
      name: "Mail",
      url: "mailto:asingh278@wisc.edu",
    },
  ],

  //-- NAVIGATION SETTINGS -----
  navLinks: {
    menu: [
      {
        name: "Journaling",
        url: "/#changelog",
      },
      {
        name: "Projects",
        url: "/#projects",
      },
      {
        name: "Contact",
        url: "/#contact",
      },
    ],
    button: {
      useFileName: true,
      name: "Resume",
      fileName: "singh_arundhati_resume.pdf", // the file has to be placed inside the static folder at the root level
      url: "", // if useFileName=false, you can set an anchor link here and use the button for navigational purposes
    },
  },
  footerLinks: [],
}
